/**
 * Utilizzato per ricavare se presente il risultato di condizioni custom e specifiche dell'applicativo
 * @param acl
 * @returns {*|boolean}
 * @private
 */
function _isCustomLogic(acl) {
  return ((acl['isCustom'] != undefined && acl.isCustom) || acl['isCustom'] == undefined);
}

export const permissions = {
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la creazione di un soggetto
   * @param acl
   * @return {boolean|*|boolean}
   */
  create_soggetto: (acl) => { return acl.isNotaio && !acl.isGestionale && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per permettere azioni al click su una riga di una tabella
   * @param acl
   * @return {boolean|*|boolean}
   */
  table_is_clickable: (acl) => { return acl.isNotaio && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per l'aggiornamento di un soggetto
   * @param acl
   * @return {boolean|*|boolean}
   */
  edit_soggetto: (acl) => { return acl.isNotaio && !acl.isGestionale && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la creazione di una checklist
   * @param acl
   * @return {boolean|*|boolean}
   */
  create_checklist: (acl) => { return acl.isNotaio && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la validazione di una checklist
   * @param acl
   * @return {boolean|*|boolean}
   */
  validate_checklist: (acl) => { return acl.isNotaio && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per l'aggiornamento di una checklist
   * @param acl
   * @return {boolean|*|boolean}
   */
  edit_checklist: (acl) => { return acl.isNotaio && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per l'upload di documenti
   * @param acl
   * @return {boolean|*|boolean}
   */
  upload_document: (acl) => { return acl.isNotaio && !acl.isGestionale && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la cancellazione di documenti
   * @param acl
   * @return {boolean|*|boolean}
   */
  delete_document: (acl) => { return acl.isNotaio && !acl.isGestionale && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la modifica di documenti
   * @param acl
   * @return {boolean|*|boolean}
   */
  edit_document: (acl) => { return acl.isNotaio && !acl.isGestionale && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la modifica dei dati dei dettaglio di una pratica
   * @param acl
   * @return {*|false|boolean}
   */
  edit_pratica_details: (acl) => { return acl.isNotaio || !acl.isGestionale && _isCustomLogic(acl)},
  /**
   * Permesso da applicare a tutti quegli elementi che operano per la comparsa del warning di atttività da svolgere su una o più checklist
   * @param acl
   * @return {boolean|*|boolean}
   */
  checklist_warning_alert: (acl) => { return acl.isCittadino && _isCustomLogic(acl)},
}